/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dashboard_Daily_Usage_Mode_TokensInputs */



/**
* | output |
* | --- |
* | "Tokens" |
*
* @param {Dashboard_Daily_Usage_Mode_TokensInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const dashboard_daily_usage_mode_tokens = /** @type {((inputs?: Dashboard_Daily_Usage_Mode_TokensInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dashboard_Daily_Usage_Mode_TokensInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Token")
	return /** @type {LocalizedString} */ ("Tokens")
});